<div
	[ngStyle]="{ 'border-radius': type === 'radio' ? '50%' : null }"
	class="{{ type === 'checkbox' ? 'border-radius' : null }} {{ backgroundColor }} center {{ !isDisabled ? 'pointer' : 'not-allowed setOpacityLow' }} {{
		!hasHeightWidth ? 'wdth24 ht24 ln-height24' : null
	}} {{ height }} {{ width }} noExit relative in-block dark-border"
	(click)="onCheckClick()"
>
	<i *ngIf="isChecked" class="fa fa-check noExit lime-green-text absolute center-unknown-height-width" aria-hidden="true"></i>
</div>
